import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';

// Import language detection
import { useLanguage, languages, defaultLanguage } from './context/LanguageContext';

// Import analytics service
import { initializeGTM, initializeGA } from './services/analyticsService';

// Initialize analytics
initializeGTM();
initializeGA();

// The root wrapper that handles language detection and routing
const Root = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          {/* Default route */}
          <Route path="/" element={<App />} />
          
          {/* Language variants */}
          <Route path="/de/*" element={<App defaultLanguage="de" />} />
          <Route path="/fr/*" element={<App defaultLanguage="fr" />} />
          
          {/* Regional hubs */}
          <Route path="/us/*" element={<App region="us" />} />
          <Route path="/africa/*" element={<App region="africa" />} />
          <Route path="/asia/*" element={<App region="asia" />} />
          <Route path="/ch/*" element={<App region="ch" />} />
          
          {/* Feature pages */}
          <Route path="/how-it-works" element={<App page="how-it-works" />} />
          <Route path="/methodology" element={<App page="methodology" />} />
          <Route path="/contribution-guidelines" element={<App page="contribution-guidelines" />} />
          <Route path="/contribute" element={<App page="contribution-guidelines" />} />
          <Route path="/crowdsourcing" element={<App page="crowdsourcing" />} />
          <Route path="/case-studies" element={<App page="case-studies" />} />
          <Route path="/faq" element={<App page="faq" />} />
          <Route path="/api-docs" element={<App page="api-docs" />} />
          
          {/* Redirect missing routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
};

// Initialize the app
Root();